<template>
  <div>
    <!-- 顶部tab切换 -->
    <div class="function-nav">
      <!-- <div class="nav-tabs">
        <span v-for="tab in tabs" :key="tab.label" class="tab" :class="{active: activeTab === tab.label}" @click="switchTab(tab)">{{ tab.label }}</span>
      </div> -->
      <!-- <div class="refresh-btn">
        <button @click="onRefresh" style="background:#4caf50;color:#fff;border:none;padding:4px 16px;border-radius:4px;">刷新</button>
      </div> -->
    </div>
    
    <!-- 新增按钮 -->
    <div style="margin: 16px 0 8px 8px;">
      <button class="search-btn-green" @click="openAddForm" style="background:#4caf50;">
        <span style="font-size:18px;font-weight:bold;"></span> 新增权限
      </button>
    </div>
    
    <!-- 表格区域 -->
    <div class="data-section">
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <th>序号</th>
              <th>用户</th>
              <!-- <th>首页权限</th> -->
              <th>环境监测权限</th>
              <th>AI全域智控权限</th>
              <th>智慧宿舍权限</th>
              <th>智能巡更权限</th>
              <th>用户管理权限</th>
              <th>创建时间</th>
              <th>更新时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="11" style="text-align:center;color:#bbb;">数据加载..</td>
            </tr>
            <tr v-else-if="permissionList.length === 0">
              <td colspan="11" style="text-align:center;color:#bbb;">暂无数据</td>
            </tr>
            <template v-if="permissionList.length > 0">
              <tr v-for="(item, idx) in pagedList" :key="item.id">
                <td>{{ (page-1)*pageSize + idx + 1 }}</td>
                <td>{{ item.username }}</td>
                <!-- <td>
                  <span :style="{color: item.home_page ? '#4caf50' : '#f44336', fontWeight: 'bold'}">
                    {{ item.home_page ? '是' : '否' }}
                  </span>
                </td> -->
                <td>
                  <span :style="{color: item.environmental ? '#4caf50' : '#f44336', fontWeight: 'bold'}">
                    {{ item.environmental ? '是' : '否' }}
                  </span>
                </td>
                <td>
                  <span :style="{color: item.aicontrol ? '#4caf50' : '#f44336', fontWeight: 'bold'}">
                    {{ item.aicontrol ? '是' : '否' }}
                  </span>
                </td>
                <td>
                  <span :style="{color: item.hostel ? '#4caf50' : '#f44336', fontWeight: 'bold'}">
                    {{ item.hostel ? '是' : '否' }}
                  </span>
                </td>
                <td>
                  <span :style="{color: item.patrol ? '#4caf50' : '#f44336', fontWeight: 'bold'}">
                    {{ item.patrol ? '是' : '否' }}
                  </span>
                </td>
                <td>
                  <span :style="{color: item.user ? '#4caf50' : '#f44336', fontWeight: 'bold'}">
                    {{ item.user ? '是' : '否' }}
                  </span>
                </td>
                <td>{{ formatDate(item.created_at) }}</td>
                <td>{{ formatDate(item.updated_at) }}</td>
                <td>
                  <div class="table-action-btns">
                    <button class="search-btn-green" @click="showPermissionEdit(item)">编辑</button>
                    <button class="search-btn-green" @click="deletePermission(item)" style="background:#f44336;">删除</button>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      
      <!-- 分页 -->
      <div class="pagination">
        <button class="page-btn" :disabled="page===1" @click="changePage(1)">«</button>
        <button class="page-btn" :disabled="page===1" @click="changePage(page-1)">&lt;</button>
        <span v-for="p in displayPages" :key="p">
          <button class="page-btn" :class="{active:page===p}" @click="changePage(p)">{{p}}</button>
        </span>
        <button class="page-btn" :disabled="page===totalPages" @click="changePage(page+1)">&gt;</button>
        <button class="page-btn" :disabled="page===totalPages" @click="changePage(totalPages)">»</button>
        <div class="page-jump">
          <input type="text" v-model="pageInput" style="width:50px;" />
          <button class="jump-btn" @click="jumpPage">跳转</button>
        </div>
      </div>
    </div>
    
    <!-- 新增/编辑表单弹窗 -->
    <div v-if="showAddForm" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
      <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:600px;position:relative;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
          <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">{{ isEditMode ? '编辑权限' : '新增权限' }}</span>
          <button @click="closeAddForm" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
        </div>
        <div style="margin-bottom:24px;padding:12px 16px;background:#f5f5f5;border-radius:6px;color:#666;font-size:14px;">
          <span style="color:#e74c3c;">*</span> 为必填字段，请确保信息完整准确
        </div>
        <form class="edit-form">
          <div class="edit-form-row">
            <label><span class="required">*</span>用户名：</label>
            <input v-model="form.username" class="form-input" placeholder="请输入用户名" :readonly="isEditMode" />
          </div>
          <!-- <div class="edit-form-row">
            <label>首页权限：</label>
            <input type="checkbox" v-model="form.home_page" style="width:20px;height:20px;margin-left:10px;" />
            <span style="margin-left:8px;color:#666;">启用首页访问权限</span>
          </div> -->
          <div class="edit-form-row">
            <label>环境监测权限：</label>
            <input type="checkbox" v-model="form.environmental" style="width:20px;height:20px;margin-left:10px;" />
            <span style="margin-left:8px;color:#666;">启用环境监测模块权限</span>
          </div>
          <div class="edit-form-row">
            <label>AI全域智控权限：</label>
            <input type="checkbox" v-model="form.aicontrol" style="width:20px;height:20px;margin-left:10px;" />
            <span style="margin-left:8px;color:#666;">启用AI全域智控模块权限</span>
          </div>
          <div class="edit-form-row">
            <label>智慧宿舍权限：</label>
            <input type="checkbox" v-model="form.hostel" style="width:20px;height:20px;margin-left:10px;" />
            <span style="margin-left:8px;color:#666;">启用智慧宿舍模块权限</span>
          </div>
          <div class="edit-form-row">
            <label>智能巡更权限：</label>
            <input type="checkbox" v-model="form.patrol" style="width:20px;height:20px;margin-left:10px;" />
            <span style="margin-left:8px;color:#666;">启用智能巡更模块权限</span>
          </div>
          <div class="edit-form-row">
            <label>用户管理权限：</label>
            <input type="checkbox" v-model="form.user" style="width:20px;height:20px;margin-left:10px;" />
            <span style="margin-left:8px;color:#666;">启用用户管理模块权限</span>
          </div>
          <div style="display:flex;justify-content:center;margin-top:32px;gap:16px;">
            <button type="button" class="search-btn-green" @click="onSubmit">保存</button>
            <button type="button" class="clear-btn" @click="closeAddForm">取消</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HTTP_CONFIG } from '@/config/config.js'

export default {
  name: 'PermissionManagement',
  data() {
    return {
      tabs: [
        { label: '权限管理' }
      ],
      activeTab: '权限管理',
      page: 1,
      pageSize: 10,
      pageInput: '1',
      showAddForm: false,
      isEditMode: false,
      form: {
        username: '',
        home_page: false,
        environmental: false,
        aicontrol: false,
        hostel: false,
        patrol: false,
        user: false
      },
      permissionList: [],
      loading: false,
      totalCount: 0
    }
  },
  computed: {
    ...mapGetters(['getUserInfo']),
    pagedList() {
      // 直接返回从后端获取的分页数据，不需要前端再次分页
      return this.permissionList;
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.totalCount/this.pageSize));
    },
    
    // 新增：生成显示的页码范围，最多显示10页
    displayPages() {
      const total = this.totalPages;
      const current = this.page;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    // 获取权限列表
    async loadData() {
      this.loading = true;
      try {
        const params = new URLSearchParams();
        params.append('page', this.page);
        params.append('page_size', this.pageSize);
        
        // const userInfo = this.getUserInfo;
        
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/setperms/?${params}`, {
          method: 'GET',
          headers: {
            // 'Username': userInfo.username,
            // 'Timestamp': userInfo.timestamp,
            // 'Token': userInfo.token
          }
        });
        
        const data = await response.json();
        
        if (data.code === 200 && data.data) {
          this.permissionList = data.data.results || [];
          this.totalCount = data.data.count || 0;
          this.pageInput = this.page.toString();
        } else {
          throw new Error(data.message || '获取数据失败');
        }
      } catch (error) {
        console.error('加载权限数据失败:', error);
        this.permissionList = [];
        this.totalCount = 0;
        alert(`加载数据失败: ${error.message}`);
      } finally {
        this.loading = false;
      }
    },
    
    switchTab(tab) {
      this.activeTab = tab.label;
      this.page = 1;
      this.loadData();
    },
    
    onRefresh() {
      this.loadData();
    },
    
    changePage(newPage) {
      if (newPage >= 1 && newPage <= this.totalPages) {
        this.page = newPage;
        this.loadData();
      }
    },
    
    jumpPage() {
      let p = parseInt(this.pageInput);
      if (!isNaN(p) && p >= 1 && p <= this.totalPages) {
        this.page = p;
        this.loadData();
        this.pageInput = p.toString();
      } else {
        this.pageInput = this.page.toString();
        alert('请输入有效的页码');
      }
    },
    
    openAddForm() {
      this.isEditMode = false;
      this.resetForm();
      this.showAddForm = true;
    },
    
    closeAddForm() {
      this.showAddForm = false;
      this.resetForm();
      this.isEditMode = false;
    },
    
    resetForm() {
      this.form = {
        username: '',
        home_page: false,
        environmental: false,
        aicontrol: false,
        hostel: false,
        patrol: false,
        user: false
      };
    },
    
    showPermissionEdit(item) {
      this.form = {
        username: item.username,
        home_page: item.home_page,
        environmental: item.environmental,
        aicontrol: item.aicontrol,
        hostel: item.hostel,
        patrol: item.patrol,
        user: item.user
      };
      this.isEditMode = true;
      this.showAddForm = true;
    },
    
    async onSubmit() {
      if (!this.form.username) {
        alert('请输入用户名');
        return;
      }
      
      let submitButton;
      let originalText;
      
      try {
        submitButton = event.target;
        originalText = submitButton.textContent;
        submitButton.textContent = '提交中..';
        submitButton.disabled = true;
        
        // const userInfo = this.getUserInfo;
        const url = this.isEditMode 
          ? `${HTTP_CONFIG.SERVER_ADDR}/setperms/${this.form.username}/`
          : `${HTTP_CONFIG.SERVER_ADDR}/setperms/`;
        
        const method = this.isEditMode ? 'PATCH' : 'POST';
        
        const response = await fetch(url, {
          method: method,
          headers: {
            'Content-Type': 'application/json',
            // 'Username': userInfo.username,
            // 'Timestamp': userInfo.timestamp,
            // 'Token': userInfo.token
          },
          body: JSON.stringify(this.form)
        });
        
        const result = await response.json();
        
        if (result.code === 200) {
          const action = this.isEditMode ? '编辑' : '新增';
          alert(`权限${action}成功！`);
          this.closeAddForm();
          this.loadData();
        } else {
          throw new Error(result.message || '操作失败');
        }
        
      } catch (error) {
        console.error('提交失败:', error);
        alert(`操作失败: ${error.message}`);
      } finally {
        if (submitButton && originalText) {
          submitButton.textContent = originalText;
          submitButton.disabled = false;
        }
      }
    },
    
    async deletePermission(item) {
      if (!confirm(`确定要删除用户"${item.username}" 的权限吗？`)) {
        return;
      }
      
      try {
        // const userInfo = this.getUserInfo;
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/setperms/${item.username}/`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            // 'Username': userInfo.username,
            // 'Timestamp': userInfo.timestamp,
            // 'Token': userInfo.token
          },
          body: JSON.stringify({
            // username: item.username
          })
        });
        
        const result = await response.json();
        
        if (result.code === 200) {
          alert('删除成功！');
          this.loadData();
        } else {
          throw new Error(result.message || '删除失败');
        }
        
      } catch (error) {
        console.error('删除失败:', error);
        alert(`删除失败: ${error.message}`);
      }
    },
    
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    }
  }
}
</script>

<style scoped>
.edit-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.edit-form-row {
  display: flex;
  align-items: center;
}

.edit-form-row label {
  color: #222;
  font-size: 16px;
  min-width: 120px;
  text-align: right;
  margin-right: 12px;
}

.edit-form-row .form-input {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 15px;
  min-width: 200px;
  outline: none;
  transition: border 0.2s;
}

.edit-form-row .form-input:focus {
  border: 1.5px solid #4caf50;
}

.required {
  color: #e74c3c;
  margin-right: 4px;
}

.modal-content {
  max-height: 80vh;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .edit-form-row {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .edit-form-row label {
    min-width: auto;
    margin-bottom: 8px;
  }
  
  .edit-form-row .form-input {
    min-width: 100%;
  }
}

.clear-btn {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 8px;
  transition: all 0.2s;
}

.clear-btn:hover {
  background: #e8e8e8;
  border-color: #ccc;
}
</style> 
